import React, { useEffect, useState } from 'react';
import { FiMenu, FiX } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './NavbarChall.css';
import './Sidebar.css'

import { useHistory } from 'react-router';
import Cookies from 'universal-cookie';
const NavbarChall = () => {
	const cookies = new Cookies();
	const [open, setOpen] = useState(false);
	const [showA, setShowA] = useState(false);
	const history = useHistory();
	const handleClick = () => {
		setOpen(!open);
	};
  
	const closeMenu = () => {
		setOpen(false);
	};
    const Logout = () => {
		cookies.remove('tokenCTF', { path: '/' });
		history.push({pathname:'/'});		
	}
	useEffect(() => {
		axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/users/isAdmin`, {
			headers: { 'Authorization': cookies.get('tokenCTF') }
		}).then((response) => {
				if(response.data.isAdmin===true){
					setShowA(true);
				}
				else{
					setShowA(false);
				}
			
		});
	});
	return (
		<nav className="navbar-chall">
			<Link to="/user" className="nav-logo-chall">
			<img src='/logoUDLA.png' alt='logoUdla' className="logo-udla-chall"></img>
			</Link>
			<div onClick={handleClick} className="nav-icon-chall">
				{open ? <FiX /> : <FiMenu />}
			</div>
			<ul className={open ? 'nav-links-chall active' : 'nav-links-chall'}>
				<li className="nav-item-chall">
					<Link to="/user/retos" className="nav-link-chall" onClick={closeMenu}>
						Retos
					</Link>
				</li>
				<li className="nav-item-chall">
					<Link to="/user/puntuaciones" className="nav-link-chall" onClick={closeMenu}>
						Puntuaciones
					</Link>
				</li>
				<li className="nav-item-chall">
					<Link to="/user/equipos"  className="nav-link-chall" onClick={closeMenu}>
						Equipo
					</Link>
				</li>
				<li className="nav-item-chall">
					<Link to="/user/perfil" className="nav-link-chall nav-button-chall" onClick={closeMenu}>
					 Perfil
					</Link>
				</li>
				<li className="nav-item-chall">
					<Link to="/user/aprendizaje"  className="nav-link-chall nav-button-chall" onClick={closeMenu}>
					 Aprender
					</Link>
				</li>
				<li className="nav-item-chall">
					<Link to="/user/writeups" className="nav-link-chall nav-button-chall" onClick={closeMenu}>
					 Writeups
					</Link>
				</li>
				<li className= {showA? "nav-item-chall" : "invisible-item"} >
					<Link to="/admin" className="nav-link nav-button" onClick={closeMenu}>
					 Admin
					</Link>
				</li>
				<li className="nav-item-chall">
				<button onClick={(e)=>{Logout()}}> Logout </button>
				</li>
			</ul>
		</nav>
	);
};

export default NavbarChall;